import { useSuspenseQuery } from '@apollo/client';
import React, { Suspense } from 'react';
import { Navigate, useParams } from 'react-router-dom';

import { Skeleton, Stack, Text } from '@eluve/components';
import {
  AppointmentContextProvider,
  getAppointmentDetailsQuery,
} from '@eluve/frontend-appointment-hooks';
import { useTranslation } from '@eluve/i18n';

import { SummaryComparison } from './SummaryComparison';

const SkeletonLine: React.FC = () => {
  return <Skeleton className="h-6 w-full bg-white" />;
};

export const SummaryComparisonPage: React.FC = () => {
  const { t } = useTranslation();
  const { tenantId, appointmentId } = useParams() as {
    tenantId: string;
    appointmentId: string;
  };

  const {
    data: { appointmentsByPk: appointment },
  } = useSuspenseQuery(getAppointmentDetailsQuery, {
    variables: {
      tenantId,
      appointmentId,
    },
  });

  if (appointment === null) {
    return <Navigate to="/404" />;
  }

  return (
    <Suspense
      fallback={
        <Stack className="container mt-24" gap={2} align="stretch">
          <Text>{t('appointmentPage.summaryComparison.loading')}</Text>
          <SkeletonLine />
          <SkeletonLine />
          <SkeletonLine />
        </Stack>
      }
    >
      <AppointmentContextProvider
        tenantId={tenantId}
        appointmentId={appointmentId}
      >
        <SummaryComparison />
      </AppointmentContextProvider>
    </Suspense>
  );
};
